import { db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import {startLoading, stopLoading} from "../loader";

export async function createPrice(userInfos, price) {
    startLoading();
    let snap = await db.ref(`users/${userInfos.uid}/CityTariffs`).push(price);
    snap = await db
        .ref(`users/${userInfos.uid}/CityTariffs/${snap.key}`)
        .update({ id: snap.key });

    stopLoading();

    return snap;
}

export async function updatePrice(userInfos, price) {
    startLoading();

    await db.ref(`users/${userInfos.uid}/CityTariffs/${price.id}`).update(price);

    stopLoading();
}

export async function deletePrice(userInfos, price_id) {
    if (!Array.isArray(price_id)) {
        price_id = [price_id];
    }

    startLoading();

    let pList = price_id.map(async (id) => {
        if (id) await db.ref(`users/${userInfos.uid}/CityTariffs/${id}`).remove();
    });

    await Promise.all(pList);

    stopLoading();
}

export function usePrices() {
    const { userInfos } = useContext(UserContext);
    const [prices, setPrices] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        db.ref("users/" + userInfos.uid + "/CityTariffs")
            .once("value")
            .then((snapshot) => {
                let res = [];
                snapshot.forEach(function (childSnapshot) {
                    res.push({
                        id: childSnapshot.key,
                        ...childSnapshot.val(),
                    });
                });
                setPrices(res);
                setLoaded(true);
            });
    }, [userInfos.uid]);

    return { prices, loaded };
}
